import { useSelector, shallowEqual } from 'react-redux';
import type { LocationState } from 'redux-first-router';

interface State {
  slug: string;
}

export const useArticleSlug = () => {
  const { slug } = useSelector<{ location: LocationState }, State>((state) => {
    const { payload } = state.location;
    return {
      slug: payload.slug,
    };
  }, shallowEqual);

  return slug;
};
